import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { LogDataService } from 'tnx-admin-service/logdata/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'logdata',
    templateUrl: './logdata.component.html',
    styleUrls: ['./logdata.component.scss'],
    providers: [ComponentContextService],
})
export class LogDataComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _logDataService: LogDataService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._logDataService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'data', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'action', name: 'Loại hành động', fullName: 'Loại hành động', description: 'Loại hành động' }),
            new ModelSchema({ field: 'browserName', name: 'Tên trình duyệt', fullName: 'Tên trình duyệt', description: 'Tên trình duyệt' }),
            new ModelSchema({ field: 'browserVersion', name: 'Phiên bản trình duyệt', fullName: 'Phiên bản trình duyệt', description: 'Phiên bản trình duyệt' }),
            new ModelSchema({ field: 'device', name: 'Tên thiết bị', fullName: 'Tên thiết bị', description: 'Tên thiết bị' }),
            new ModelSchema({ field: 'oS', name: 'Hệ điều hành', fullName: 'Hệ điều hành', description: 'Hệ điều hành' }),
            new ModelSchema({ field: 'subsystem', name: 'Phân hệ', fullName: 'Phân hệ', description: 'Phân hệ' }),
            new ModelSchema({ field: 'function', name: 'Chức năng', fullName: 'Chức năng', description: 'Chức năng' }),
            new ModelSchema({ field: 'localIp', name: 'Địa chỉ IP nội bộ', fullName: 'Địa chỉ IP nội bộ', description: 'Địa chỉ IP nội bộ' }),
            new ModelSchema({ field: 'publicIp', name: 'Địa chỉ IP public', fullName: 'Địa chỉ IP public', description: 'Địa chỉ IP public' }),
            new ModelSchema({ field: 'displayContent', name: 'Nội dung có ý nghĩa (compile bởi dịch vụ template)', fullName: 'Nội dung có ý nghĩa (compile bởi dịch vụ template)', description: 'Nội dung có ý nghĩa (compile bởi dịch vụ template)' }),
            new ModelSchema({ field: 'location', name: 'Địa chỉ vật lý', fullName: 'Địa chỉ vật lý', description: 'Địa chỉ vật lý' }),
            new ModelSchema({ field: 'region', name: 'Vùng địa lý', fullName: 'Vùng địa lý', description: 'Vùng địa lý' }),
            new ModelSchema({ field: 'city', name: 'Thành phố', fullName: 'Thành phố', description: 'Thành phố' }),
            new ModelSchema({ field: 'country', name: 'Quốc Gia', fullName: 'Quốc Gia', description: 'Quốc Gia' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'created', name: 'Thời gian tạo', fullName: 'Thời gian tạo', description: 'Thời gian tạo' }),
            new ModelSchema({ field: 'createdBy', name: 'Tác nhân', fullName: 'Tác nhân', description: 'Tác nhân' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'action' }),
            new ColumnSchemaBase({ field: 'created', dataType: 'datetime' }),
            new ColumnSchemaBase({ field: 'createdBy', dataType: 'user' }),
            new ColumnSchemaBase({ field: 'browserName' }),
            new ColumnSchemaBase({ field: 'browserVersion' }),
            new ColumnSchemaBase({ field: 'publicIp' }),
        ];

        this.setting.popupSize.width = 1071;
        this.setting.popupSize.height = 850;
        this.setting.title = 'Nhật ký hệ thống';
        super.ngOnInit();
    }
}

